import React, { useEffect } from "react";
import "./modalDisabledForm.scss";
import { useStaticQuery, graphql, navigate } from "gatsby";
import Button from "../../atoms/button/button";
import rawToReact from "../../../utils/rawToReact";

interface ModalProps {
    showModal: boolean;
}

const ModalDisableForm: React.FC<ModalProps> = ({ showModal }) => {
    useEffect(() => {
        document.body.style.overflow = showModal ? "hidden" : "unset";
    }, [showModal]);

    const modalData = useStaticQuery(graphql`
        query MODALDISABLED{
            contentfulContactenos(contentful_id: { eq: "1SKBZLzF78Ki85bTdR7xpy" }) {
                imagenesEmpleo {
                    file {
                        url
                    }
                }
                tituloPrincipal
                redireccionBoton
                tituloBoton
                descripcion {
                    raw
                }
            }
        }
    `);

    const {
        imagenesEmpleo,
        tituloPrincipal,
        descripcion,
        tituloBoton,
        redireccionBoton
    } = modalData.contentfulContactenos;

    if (!showModal) return null;

    return (
        <div className="m-modal-disabled">
            <div className="m-modal-disabled__overlay">
                <div className="m-modal-disabled__box">
                    <button
                        type="button"
                        className="m-modal-disabled__close-button"
                        onClick={() => navigate(redireccionBoton)}
                    >
                    </button>
                    <div className="m-modal-disabled__content">
                        <img
                            className="m-modal-disabled__icon"
                            src={imagenesEmpleo[0]?.file.url}
                            alt="Illustration"
                        />
                        {/* Barra agregada debajo de la imagen */}
                        <div className="m-modal-disabled__separator"></div>
                        
                        <h2 className="m-modal-disabled__title">{tituloPrincipal}</h2>
                        <p className="m-modal-disabled__description">
                            {rawToReact(descripcion.raw)}
                        </p>
                        <div className="m-modal-disabled__buttonsBox">
                            <Button
                                classname="a-button__magenta"
                                onClickAction={() => navigate(redireccionBoton)}
                                isDisabled={false}
                                type="button"
                                text={tituloBoton}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalDisableForm;
